import { RoleModelView } from 'abi-opr-common-types';

export function formatRolesToString(roles?: RoleModelView): string[] {
  if (!roles) return [];

  return Object.entries(roles)
    .filter(([, value]) => value)
    .map(([key]) => key);
}
